/**
 * ArkTabs - Tab组件JS辅助函数
 */
(function () {
    if (window.ArkTabs) return;

    window.ArkTabs = {
        /**
         * 获取Tab元素相对于容器的位置
         */
        getTabRect: function (container, tabElement) {
            if (!container || !tabElement) return null;

            var containerRect = container.getBoundingClientRect();
            var tabRect = tabElement.getBoundingClientRect();

            return {
                width: tabRect.width,
                left: tabRect.left - containerRect.left + container.scrollLeft
            };
        },

        /**
         * 获取滚动状态
         */
        getScrollState: function (container) {
            if (!container) return null;

            var scrollLeft = container.scrollLeft;
            var scrollWidth = container.scrollWidth;
            var clientWidth = container.clientWidth;
            var maxScrollLeft = scrollWidth - clientWidth;

            return {
                scrollLeft: scrollLeft,
                maxScrollLeft: maxScrollLeft,
                hasOverflow: scrollWidth > clientWidth
            };
        },

        /**
         * 滚动容器
         */
        scroll: function (container, delta) {
            if (!container) return;

            container.scrollBy({
                left: delta,
                behavior: 'smooth'
            });
        },

        /**
         * 滚动到指定Tab
         */
        scrollToTab: function (container, tabElement) {
            if (!container || !tabElement) return;

            var containerRect = container.getBoundingClientRect();
            var tabRect = tabElement.getBoundingClientRect();

            // 计算Tab相对于容器可视区域的位置
            var tabLeft = tabRect.left - containerRect.left;
            var tabRight = tabLeft + tabRect.width;

            // 如果Tab在左侧不可见
            if (tabLeft < 0) {
                container.scrollBy({
                    left: tabLeft - 16, // 留一点边距
                    behavior: 'smooth'
                });
            }
            // 如果Tab在右侧不可见
            else if (tabRight > containerRect.width) {
                container.scrollBy({
                    left: tabRight - containerRect.width + 16,
                    behavior: 'smooth'
                });
            }
        },

        /**
         * 更新指示器位置 (可选：用于更复杂的动画)
         */
        updateIndicator: function (container, indicator, tabElement) {
            if (!container || !indicator || !tabElement) return;

            var rect = this.getTabRect(container, tabElement);
            if (rect) {
                indicator.style.width = rect.width + 'px';
                indicator.style.left = rect.left + 'px';
                indicator.style.opacity = '1';
            }
        }
    };
})();
